//
//
//
//
//
//

export default {
  name: 'DivSpan',
  props: ['dictCode', 'dictItemCode', 'index'], // dictCode：表, dictItemCode：值, index：截取 0 - ？个字符
  data() {
    return {
      message: {
        value:''
      },
    }
  },
  mounted() {
    if (this.dictItemCode) {
      this.dictCached();
    }

  },
  methods: {
    dictCached(){
      let dictItems=localStorage.getItem(this.dictCode);
      this.message.value = '';
      if(dictItems){
        dictItems=JSON.parse(dictItems);
      }
      let arr = [];
      if(this.dictItemCode){
        arr = this.dictItemCode.split(',');
      }
      if(dictItems && dictItems.length){
        arr.forEach((item) => {
          for(let i=0;i<dictItems.length;i++){
            if(item === dictItems[i].code){
              this.message.value += (dictItems[i].value + ',');
              break;
            }
          }
        });
        if(this.message.value){
          this.message.value = this.message.value.substr(0,this.message.value.length-1);
        }
      }else {
        this.$get('api/dict-tables/search-with-list',{dictCode:this.dictCode}).then(res=>{
          let dictItems = res.dictItems;
          if(dictItems){
            arr.forEach((item) => {
              for(let i=0;i<dictItems.length;i++){
                if(item === dictItems[i].code){
                  this.message.value += (dictItems[i].value + ',');
                  break;
                }
              }
            });
            if(this.message.value){
              this.message.value = this.message.value.substr(0,this.message.value.length-1);
            }
          }
          let dictItemStr=JSON.stringify(res.dictItems);
          localStorage.setItem(this.dictCode,dictItemStr);
        })
      }
    },
  },
  watch: {
    dictItemCode() {
      if (!this.dictItemCode) {
        this.message = {value:''};
        return;
      }
      this.dictCached();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DivSpan.vue